import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {
    view: false
  },
  text: {
    import: {
      de: "Daten importieren",
      en: "Import Data",
      nl: "Gegevens importeren"
    },
    importFile: { de: "Import now", en: "Import now", nl: "Import now" },
    selectType: {
      de: "Bitte wählen Sie den Datentyp, den Sie importieren möchten",
      en: "Please select data type that you would like to import",
      nl: "Selecteer het gegevenstype dat u wilt importeren."
    },
    next: { de: "Nächster Schritt", en: "Next step", nl: "Volgende stap" },
    previous: {
      de: "Vorheriger Schritt",
      en: "Previous step",
      nl: "Vorige stap"
    },
    selectFile: {
      de: "Bitte wählen Sie die Datei aus, die Sie hochladen möchten",
      en: "Please select the file you would like to upload",
      nl: "Selecteer het bestand dat u wilt uploaden"
    },
    summary: {
      de: "Zusammenfassung",
      en: "Summary",
      nl: "Samenvatting"
    },
    random: {
      de: "Testdaten erzeugen",
      en: "Create test data",
      nl: "Maak testgegevens aan"
    },
    upload: {
      de: "Datei hochladen",
      en: "Upload file",
      nl: "Bestand uploaden"
    },
    save: {
      de: "Importdaten speichern",
      en: "Save",
      nl: "Import data bewaren"
    },
    clear: {
      de: "Clear",
      en: "Clear",
      nl: "Clear"
    },
    discard: {
      de: "Importdaten verwerfen",
      en: "Discard import data",
      nl: "Import data verwijderen"
    },
    deleteAllDocs: {
      de: "Sind Sie sicher, dass Sie alle Dokumente löschen möchten?",
      en: "Are you sure you want to delete all documents?",
      nl: "Weet u zeker dat u alle documenten wilt verwijderen? "
    },
    deleteAllDocsType: {
      de: "Alle Dokumente löschen",
      en: "Delete all documents",
      nl: "Alle documenten verwijderen"
    },
    deleteTitle: {
      de: "Dokumente löschen",
      en: "Delete documents",
      nl: "Verwijder documenten"
    },
    documentsSavedSuccesfully: {
      de: "Dokumente erfolgreich gespeichert",
      en: "Documents saved successfully",
      nl: "Succesvol opgeslagen documenten"
    },
    documentsDeletedSuccesfully: {
      de: "Dokumente erfolgreich gelöscht",
      en: "Documents deleted successfully",
      nl: "Documenten succesvol verwijderd"
    },
    structure: {
      de: "Baugruppe",
      en: "Assembly",
      nl: "Samenstelling"
    },
    fieldsMissing: {
      de: "Die folgenden Felder konnten nicht mit einer vorhandenen Eigenschaft abgeglichen werden",
      en: "The following fields could not be matched to an existing property",
      nl: "De volgende velden konden niet worden gekoppeld aan een bestaande eigenschap"
    },
    tryAgain: {
      de: " Bitte korrigieren Sie die Überschriften und versuchen Sie es erneut!",
      en: "Please correct the headings and try again!",
      nl: "Corrigeer de koppen en probeer het opnieuw!"
    },
    column: {
      de: "Spalte:",
      en: "Column:",
      nl: "Kolom"
    },
    docExists: {
      de: "In der Datenbank gefundenes Dokument",
      en: "Document found in the database",
      nl: "Document gevonden in de database"
    },
    addItem: {
      de: "Element auswählen",
      en: "Select item",
      nl: "Selecteer item"
    },
    removeItem: {
      de: "Element abwählen",
      en: "Deselect item",
      nl: "Deselecteer item"
    },
    downloadSample: {
      de: "Beispiel herunterladen",
      en: "Download sample",
      nl: "Download voorbeeld"
    },
    options: {
      de: "Optionen",
      en: "Options",
      nl: "Opties"
    },
    choose: {
      de: "Wählen Sie eine der Optione...",
      en: "Choose one of the options...",
      nl: "Wählen Sie eine der Optione..."
    },
    select: {
      de: "Select type",
      en: "Select type",
      nl: "Select type"
    },
    review: {
      de: "Review List",
      en: "Review List",
      nl: "Review List"
    },
    manufacturerCode: {
      de: "Code des Herstellers",
      en: "Manufacturer Code",
      nl: "Manufacturer Code"
    },
    importVehiclesDuplicatesError: {
      de: "There are duplicates of vehicles in the file. Duplicates: ",
      en: "There are duplicates of vehicles in the file. Duplicates: ",
      nl: "There are duplicates of vehicles in the file. Duplicates: "
    },
    warehouseGroupsDefinition: {
      de: "Warengruppen Definition",
      en: "Warehouse Groups Definition",
      nl: "Warehouse Groups Definition"
    },
    uploadRules: {
      de: "Regeln für einen erfolgreichen Upload",
      en: "Rules for a successful upload",
      nl: "Regels voor een succesvolle upload"
    },
    rule1: {
      de: "Stellen Sie sicher, dass die Datumsfelder den folgenden Standardformaten entsprechen: '2015.03.25' / '25.Mär.2015' / 'Mär.25.2015'",
      en: "Make sure the date fields respect the following standard rules: '2015.03.25' / 'Mar.25.2015' / '25.Mar.2015'",
      nl: "Zorg ervoor dat de datumvelden de volgende standaardformaten gebruiken: '2015.03.25' / '25.mrt.2015' / 'mrt.25.2015'"
    },
    rule2: {
      de: "Stellen Sie sicher, dass alle Tabellenüberschriften mit den in Ihrem System konfigurierten Feldern übereinstimmen.",
      en: "Make sure that all table heads match the fields configured on your system.",
      nl: "Zorg ervoor dat alle tabelkoppen overeenkomen met de velden die in je systeem zijn geconfigureerd."
    },
    rule3: {
      de: "Fügen Sie '_language' zum Namen Ihres Vorlagenblatts hinzu (z. B.: 'Template_de / Template_en').",
      en: "Make sure you include '_language' to your template-sheet name (eg: 'Template_de / Template_en').",
      nl: "Voeg '_language' toe aan de naam van je sjabloonblad (bijv. 'Template_nl / Template_en')."
    },
    rule4: {
      de: "Stellen Sie sicher, dass die aktuell eingestellte Sprache mit der importierten Sprache übereinstimmt.",
      en: "Make sure that the current set language matches the imported language.",
      nl: "Zorg ervoor dat de ingestelde taal overeenkomt met de geïmporteerde taal."
    },
    filesReady: {
      de: "Ihre Datei wurde hochgeladen und kann jetzt gespeichert werden!",
      en: "Your file is uploaded and ready to be saved!",
      nl: "Je bestand is geüpload en klaar om opgeslagen te worden!"
    },
    0: {
      de: "Unerwarteter Fehler",
      en: "Unexpected Error",
      nl: "Onverwachte fout"
    },
    1: {
      de: "Keine Schlüssel angegeben",
      en: "No keys provided",
      nl: "Geen sleutels opgegeven"
    },
    2: {
      de: "Ungültige Schlüssel angegeben (Ungültige Schlüssel: $)",
      en: "Invalid keys provided (Invalid keys: $)",
      nl: "Ongeldige sleutels opgegeven (Ongeldige sleutels: $)"
    },
    3: {
      de: "Ungültiges Dateiformat. Der Dateiinhalt ist fehlerhaft. Bitte verwenden Sie die bereitgestellte JSON-Vorlage.",
      en: "Invalid file format. File content is malformed. Please use the provided JSON template.",
      nl: "Ongeldig bestandsformaat. De inhoud van het bestand is ongeldig. Gebruik de meegeleverde JSON-sjabloon."
    },
    4: {
      de: "Ungültiges Dateiformat. Der Dateiinhalt darf kein Array sein. Bitte verwenden Sie die bereitgestellte JSON-Vorlage.",
      en: "Invalid file format. File content must not be an array. Please use the provided JSON template.",
      nl: "Ongeldig bestandsformaat. De inhoud van het bestand mag geen array zijn. Gebruik de meegeleverde JSON-sjabloon."
    },
    5: {
      de: "Dateigröße zu groß. Bitte begrenzen Sie die Dateien auf maximal 52428800 Byte.",
      en: "File size too large. Please limit the files to maximum 52428800 bytes.",
      nl: "Bestandsgrootte te groot. Beperk de bestanden tot maximaal 52428800 bytes."
    },
    6: {
      de: "Bitte wählen Sie den richtigen Kunden aus.",
      en: "Please select the correct customer.",
      nl: "Selecteer de juiste klant."
    },
    7: {
      de: "Duplizierte Schlüssel werden bereitgestellt.",
      en: "Duplicated keys provided.",
      nl: "Duplicaten van sleutels worden verstrekt."
    },
    11: {
      de: "(Ungültige Elemente: $)! Unzulässige Zeichen: Tabulator, Zeilenumbruch, ! ^ ( ) [ ] { } ; ' : \" \\ | < > ? @ # $ % *)",
      en: "(Invalid items: $)! Restricted characters: tab, line break, ! ^ ( ) [ ] { } ; ' : \" \\ | < > ? @ # $ % *)",
      nl: "(Ongeldige items: $)! Verboden tekens: tab, regeleinde, ! ^ ( ) [ ] { } ; ' : \” \\ | < > ? @ # $ % *)"
    },
    invalidManufacturerRows: {
      de: "Ungültige Herstellerzeilen: $",
      en: "Invalid manufacturer rows: $",
      nl: "Ongeldige fabrikantregels: $"
    },
    duplicatedParts: {
      de: "Duplizierte Teile in der Datei gefunden. Duplikate: ",
      en: "(Duplicated parts: $)",
      nl: "Duplicated parts found in the file. Duplicates: "
    },
    duplicatedManufacturers: {
      de: "Duplizierte Hersteller in der Datei gefunden. Duplikate: ",
      en: "(Duplicated parts: $)",
      nl: "Duplicated manufacturers found in the file. Duplicates: "
    }
  },
  list: {},
  url: {},
  field: {},
  additionalInfo: {}
};

export const _import: ComponentSettings<typeof settings> = settings;
